export default "__VITE_ASSET__BVJZHi4a__"